import { useTranslation } from 'react-i18next'
import { FilterBar } from '../components/ui/FilterBar'

interface GraphFiltersProps {
  health: string
  onQuery: (q: string) => void
  onHealth: (h: string) => void
}

const HEALTH = ['healthy', 'degraded', 'down', 'unknown'] as const

/** Acotar the graph by name/tag (debounced) and by health (UX charter R1). */
export function GraphFilters({ health, onQuery, onHealth }: GraphFiltersProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-3">
      <div className="w-64">
        <FilterBar onChange={onQuery} placeholder={t('filters.search')} />
      </div>
      <select
        aria-label={t('filters.health')}
        value={health}
        onChange={(e) => onHealth(e.target.value)}
        className="rounded border border-neutral-300 px-2 py-2 text-sm dark:bg-neutral-800"
      >
        <option value="">{t('filters.allHealth')}</option>
        {HEALTH.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>
    </div>
  )
}
